export default "__VITE_ASSET__7e6c8e67__"